const initialeState = {
    products : [],
    productCount: 0,
    amountHT: 0.0,
    tax: 0.0,
    displayCart: false,
}

const ShopCartReducer = (state=initialeState, action) => {
    switch (action.type) {
        case 'TOGGLE_CART':
            return {
                ...state,
                displayCart: !state.displayCart
            }
        case "ADD_TO_CART":
            const existsInProducts = state.products.some(l => l.id === action.data.product.id)
            const prod = action.data.product
            prod.shopQuantity = action.data.quantity
            if(existsInProducts){
                return {
                    ...state,
                    products: state.products.map(product =>
                        product.id === action.data.product.id ? {...product, selected: true, shopQuantity: product.shopQuantity + action.data.quantity} : product,
                    ),
                    productCount: state.productCount+action.data.quantity,
                    amountHT: state.amountHT+action.data.totHT,
                }
            }
            return {
                ...state,
                products: [...state.products, action.data.product],
                productCount: state.productCount+action.data.quantity
             }

        case "REMOVE_FROM_CART":
            return {
                ...state,
                products: _.filter(state.products, function(o) { return o.id!=action.data.product.id }),
                productCount: _.sumBy(state.products, function(o) { return o.shopQuantity; })

            };
        case "ADD_QUANTITY":
            return {
                ...state,
                products: state.products.map(product =>
                    product.id === action.data.product.id
                        ? {...product, shopQuantity: product.shopQuantity + 1}
                        : product,
                ),
                productCount: state.productCount + 1,

            };
        case "SUB_QUANTITY":
            return {
                ...state,
                products: state.products.map(product =>
                    product.id === action.data.product.id
                        ? {
                            ...product,
                            shopQuantity: product.shopQuantity !== 1 ? product.shopQuantity - 1 : 1,
                        }
                        : product,
                ),
                productCount: (state.productCount>1 )?state.productCount-1:state.productCount
            };
        case "EMPTY_CART":
            return {
                ...state,
                products: [],
                productCount:0,
                amountHT: 0.0,
            };
        case "SET_TOTAL_AMOUNT":
            return {
                ...state,
                amountHT: action.data
            };
        case "SET_TAX":
            return {
                ...state,
                tax: action.data
            };
        default:
            return state
    }
}

export default ShopCartReducer
